export default {
  free_menu_items: 'Desbloqueado gratis',
  discount_badge: '{{value}} de descuento',
  available_at_badge: 'Disponible {{schedule}}',
  restricted_tooltip: 'Disponible {{schedule}} — cambia la hora de recogida arriba para pedir.',
};
